import auth from '@/vuex/auth/module'
import ui from '@/vuex/ui/module'

import Vue from 'vue'

// Vuex for state management
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    'auth': auth,
    'ui': ui
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js